'use strict';
import { trackAction } from 'helpers/trackingOM';

$(document).ready(function () {
    const getTrackingPosData = (element) => {
        const subMenu = $(element).closest('ul');
        const col = subMenu.prevAll('ul').length.toString();
        const row = $(element).parent('li').prevAll('li').length.toString();

        return {
            row,
            col
        }
    };

    $('footer a').click(function (e) {
        let trackingEventString = 'trackMenu';
        let element = $(e.currentTarget)[0];
        let label = $(element).attr('title').trim();
        const {row, col} = getTrackingPosData(element);
        let obj = {
            menuItemLabel: label,
            ctaText: label,
            posColNum: col,
            posRowNum: row,
            menuOrientation: 'footer'
        };
        let trackingEventParam = $(element).attr('tracking-event');
        if (trackingEventParam) {
            trackingEventString = trackingEventParam.trim();
        }
        trackAction(trackingEventString, obj);
    });
});
